<template>
  <div class="row">
    <!-- overview-->
    <div class="col-12">
      <div class="row">
        <div class="head">
          <div class="col-lg">
            <h3>Overview</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="row">
        <!-- Total Cluster -->
        <div class="col-lg-3">
          <stats-card :title="totalCluster" :sub-title="clusterTitle" :icon="clusterIcon" customClass=""
            style="height: 100px"></stats-card>
        </div>

        <!-- Total lights -->
        <div class="col-lg-3">
          <stats-card :title="totalLights" :sub-title="lightsTitle" :icon="lightsIcon" customClass=""
            style="height: 100px"></stats-card>
        </div>

        <!-- Total Cost -->
        <div class="col-lg-3">

          <stats-card message="The value calculated based on schedule for this month." customClass="fa fa-info-circle" :title="totalCost" :sub-title="costTitle" :icon="costIcon" style="height: 100px">
            
          </stats-card>
        </div>

        <!-- Total Energy -->
        <div class="col-lg-3">
          <stats-card message="The value calculated based on schedule for this month." customClass="fa fa-info-circle" :title="totalEnergy" :sub-title="energyTitle" :icon="energyIcon"
            style="height: 100px"></stats-card>
        </div>
      </div>
    </div>

    <!-- Cluster-->
    <div class="col-12">
      <div class="row">
        <div class="head">
          <div class="col-lg">
            <h3>Clusters</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- Map -->
    <div class="col-lg-6 col-md-6">
      <card type="chart" style="height: 410px">
        <loading loader="spinner" :height="70" :width="70" color="#00f2c3" background-color="#6c757d" transition="fade"
          :active="isLoading" :is-full-page="false"></loading>
        <template slot="header">
          <h3 class="card-title">
            <div id="map" class="map">
              <!-- <double-bounce></double-bounce> -->
              <l-map ref="map" style="height: 380px" :zoom="zoom" :center="center" class="sidebar-map"
                :options="{ scrollWheelZoom: false }" :bounds="bounds">
                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                <l-marker v-for="marker in markers" :lat-lng="marker.location" :key="marker.addMarker" :icon="markerIcon()"
                  @click="viewCluster(marker.clusterID)">
                  <l-tooltip :content="marker.clusterName" />
                </l-marker>
              </l-map>
            </div>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <!-- Chart -->
    <div class="col-lg-6 col-md-6">
      <card type="card-chart" no-footer-line>
        <template slot="header">
          <h3>Energy Consumption for {{ currentMonth }}</h3>
          <h5 class="card-category">Energy (kwh)</h5>
          <h3 class="card-title">
            <div class="chart-area">
              <line-chart :chart-data="lineChart1.chartData" :gradient-colors="lineChart1.gradientColors"
                :gradient-stops="lineChart1.gradientStops" :extra-options="lineChart1.extraOptions"
                :height="300"></line-chart>
            </div>
          </h3>
          <div slot="footer"></div>
        </template>
      </card>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <!-- Operational Gateway -->
        <div class="col-lg-4 col-md-6">
          <stats-card :title="operationalGateway" :sub-title="gatewayTitle" :icon="gatewayIcon" customClass=""
            style="height: 100px"></stats-card>
        </div>

        <!-- Comm Uprate -->
        <div class="col-lg-4 col-md-6">
          <stats-card :title="commUprate" :sub-title="commTitle" :icon="commIcon" style="height: 100px" customClass=""></stats-card>
        </div>

        <!-- Co2 Reduction -->
        <div class="col-lg-4 col-md-6">
          <stats-card :title="co2Reduction" :sub-title="co2ReductionTitle" :icon="co2ReductionIcon" customClass=""
            style="height: 100px"></stats-card>
        </div>

        <!-- Top 5 issues -->
        <!-- <div class="col-lg-3 col-md-6">
          <card type="chart">
            <template slot="header">
              <h5 class="card-category">Top 5 Issues</h5>
        <h3 class="card-title">-->
        <!-- table -->
        <!-- <el-table :data="tableData">
                  <el-table-column min-width="80" prop="no" label="No" align="center"></el-table-column>
                  <el-table-column min-width="150" prop="top5issues" label="Top 5 Issues"></el-table-column>
                </el-table>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import TaskList from "./TaskList";
import UserTable from "./UserTable";
import CountryMapCard from "./CountryMapCard";
import StatsCard from "src/components/Cards/StatsCard";
import swal from "sweetalert2";
import config from "@/config";
import moment from "moment";
import { DoubleBounce } from "vue-loading-spinner";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LTooltip,
} from "vue2-leaflet";
import { TabPane, Tabs, Collapse, CollapseItem } from "src/components";
import { Table, TableColumn } from "element-ui";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading,
    DoubleBounce,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    LineChart,
    StatsCard,
    TaskList,
    CountryMapCard,
    UserTable,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    TabPane,
  },
  data() {
    return {
      lightCount: 0,
      devicetoken: [],
      isLoading: false,
      clusterTariff: 0,
      totalUsedLight: 0,
      totalopp: [],
      commUp: [],
      clusterList: [],
      companyID: "",
      currentMonth: "",
      // Total Cluster
      clusterTitle: "Total Clusters",
      totalCluster: "0",
      clusterIcon: require("@/assets/img/Cluster Icon.png"),

      // Total Lights
      lightsTitle: "Total Lights",
      totalLights: "0",
      lightsIcon: require("@/assets/img/Total Lights Icon.png"),

      // Total Cost
      costTitle: "Total Cost (MYR)",
      totalCost: "0",
      costIcon: require("@/assets/img/Total Cost Icon.png"),

      // Total Energy
      energyTitle: "Total Energy (kWh)",
      totalEnergy: "0",
      energyIcon: require("@/assets/img/Energy Icon.png"),

      // Operational Gateway
      gatewayTitle: "Operational Gateways",
      operationalGateway: "0",
      totalGateways: "0",
      gatewayIcon: require("@/assets/img/Operational Gateway Icon.png"),

      // Operational Gateway
      commTitle: "Communication Uprate",
      commUprate: "0",
      commIcon: require("@/assets/img/Comm Uprate Icons.png"),

      // Operational Gateway
      co2ReductionTitle: "C02 emissions reductions",
      co2Reduction: "0",
      co2ReductionIcon: require("@/assets/img/Co2 Icons.png"),

      tableData: [
        {
          no: 1,
          top5issues: "Light Failure",
        },
        {
          no: 2,
          top5issues: "Flickering Light",
        },
        {
          no: 3,
          top5issues: "Overvoltage",
        },
        {
          no: 4,
          top5issues: "Voltage spike",
        },
        {
          no: 5,
          top5issues: "Driver failure",
        },
      ],

      // Graph
      lineChart1: {
        chartData: {
          labels: [...Array(30).keys()].map((x) => ++x),
          datasets: [
            {
              label: "Energy",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: Array(30).fill(0),
            },
          ],
        },
        extraOptions: chartConfigs.energyChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },

      // Map
      zoom: 5,
      bounds: [[3.15464, 101.718635]],
      center: L.latLng(3.15464, 101.718635),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],
      markerIcon(){
        return L.icon({
          iconSize: [30, 30], // size of the icon
          iconUrl: require("@/assets/img/marker default.png"),
        })
      },
    };
  },
  computed: {},
  methods: {
    viewCluster(c) {
      const clusterid = c;
      this.$router.push({ path: `/cluster/${clusterid}` });
    },
    calculateUpdate(id) {
    
      let promises = [];
      let d = 0;

      let payload = {
        devicelist: [],
      };

      id.map((i) => {
        payload.devicelist.push(i);
      });

      
      if (id.length > 0) {
        this.$http
          .post(":8001/api/v1/telemetry/device/status/beta/lights", payload)

          // .post(":8001/api/v1/telemetry/device/status/lights", payload)
          .then((res) => {
            if (res.error) {
           
            } else {
              let opopo = 0
            
              for (let i = 0; i < res.message.length; i++) {
                

               
                let a = moment(moment(), "hh:mm:ss");
                let b = moment(
                  moment.unix(res.message[i].last_tx_hourly),
                  "hh:mm:ss"
                );

                let c = a.diff(b, "hours");
             
               
                // c < 1 ? this.totalopp.push(1) : null;
                c < 3 ? this.totalopp.push(1) : null;
              }
              // }

              // let commUprateValue =
              //   (this.totalopp.length / this.totalLights) * 100;

              let commUprateValue = 0.00
           
              if (this.totalopp.length > 0) {
                commUprateValue = (this.totalopp.length / this.totalUsedLight) * 100;
              }

              this.commUprate = commUprateValue.toFixed(2) + "%";
            }
          });

        // for (let i = 0; i < id.length; i++) {
        //   promises.push(
        //     this.$http
        //       .post(":8001/api/v1/telemetry/device/lights/" + id[i], payload)
        //       .then(res => {
        //         if (res.error) {
        //           
        //         } else {
        //           if (res.message.status != null) {
        //             // let a = moment(moment().unix());
        //             // let b = moment(res.message.status[0].timestamp).valueOf();
        //             let a = moment(moment(), "hh:mm:ss");
        //             let b = moment(
        //               moment.unix(res.message.status[0].timestamp),
        //               "hh:mm:ss"
        //             );

        //             let c = a.diff(b, "hours");
        //           
        //             c < 1 ? this.totalopp.push(1) : null;
        //           }
        //         }
        //       })
        //   );
        // }
        Promise.all(promises).then(() => { });
      } else {
        this.commUprate = 0 + "%";
      }
    },
    getCommUprate() {
      this.commUprate = "Checking...";
      let devicetoken = [];
      this.devicetoken = []

      this.$http
        .get(":8002/api/v1/manage/device/usedevice")
        .then((res) => {
          if (res.error) {
            //pupout oeror
           
          } else {
            
           
            for (let i = 0; i < res.message.device_list.length; i++) {
              // devicetoken.push(res.message.device_list[i].devicetoken);
             

              if (res.message.device_list[i].devicetype == "nodestl" ) {
                // device token ada semua sekali termasuk yg xpakai
                this.devicetoken.push(res.message.device_list[i].devicetoken);
              }
            }
          
            

            // this.calculateUpdate(devicetoken);
            this.calculateUpdate(this.devicetoken);

          }
        })
        .catch((err) => {
          
        });
    },

    getTotalLights() {
      this.$http
        .get(":8002/api/v1/manage/device")
        .then((res) => {
          if (res.error) {
         
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
           
          } else {
            //login OK!
            
            // this.totalLights = res.message.device_list.length.toString();
          }
        })
        .catch((err) => {
         
        });
    },
    getGatewayList() {
      //Gate operational gateway list

      this.$http
        .get(":8003/api/v1/gateway")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            
            let totalOppGw = 0;

            res.message.map((i) => {
              i.Status == "1" ? (totalOppGw += 1) : 0;
            });

            this.operationalGateway = totalOppGw.toString() + " / " + res.message.length.toString();
          }
        })
        .catch((err) => {
          
        });
    },
    getTotalCluster() {
      let arrCluster = [];
      return this.$http
        .get(":8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {

            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
          } else {

            this.bounds =  []
            let data = res.message.cluster_list;
            
            this.totalCluster = res.message.cluster_list.length.toString();
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                // Push markers data
                let obj = {};
                obj["location"] = L.latLng(
                  data[i].cluster_info.lat,
                  data[i].cluster_info.lon
                );
                obj["clusterName"] = data[i].cluster_info.clustername;
                obj["clusterID"] = data[i].cluster_info.clusterid;
                this.markers.push(obj);
                this.bounds.push([
                  data[i].cluster_info.lat,
                  data[i].cluster_info.lon,
                ]);
                // Push cluster id data
                let clusterInfo = {}
                clusterInfo["id"] = data[i].cluster_info.clusterid
                clusterInfo["totalLights"] = data[i].device_list.length;

                arrCluster.push(clusterInfo);
                this.isLoading = false;
              }
            } else {
              this.isLoading = false;
            }
          }
          return arrCluster;
        })
        .catch((err) => {
          
        });
    },
    initGraph(data) {
      Promise.all(data).then((res) => {
       
        // INITIALIZE DATES BASED ON CURRENT MONTH (Y AXIS)
        let date = [];
        let dates = [];
        let energyData = [];
        let firstDay = moment().startOf("month");


        for (let i = 1; i <= moment().daysInMonth(); i++) {
          date.push(moment(firstDay).format("Do"));
          dates.push(moment(firstDay).format("D"));
          firstDay = moment(firstDay).add(1, "days");
        }

        for (let i = 0; i < moment().format("D"); i++) {
          energyData.push(0);
        }
        //////////////////////////////////////////////////////

        let currentMonth = moment().tz("Asia/Kuala_Lumpur").format("MM");

        let totalCost = [];
        let count = 0;
        // STORING ALL ENERGY DATA FOR ALL CLUSTER
        for (let i = 0; i < res.length; i++) {
          if (res[i] != undefined) {
            for (let j = 0; j < res[i].length; j++) {

              for (let s = 0; s < dates.length; s++) {
                if (res[i][j].day == dates[s]) {
                  energyData[
                    dates[s] - 1
                  // ] += parseFloat(res[i][j].val)
                  ] += parseFloat((res[i][j].val).toFixed(2))

                }
              }

              totalCost[count] =
                energyData.reduce((a, b) => a + b, 0) * res[i][0].tariff;
            }
          }

          count++;
        }

        
        this.totalEnergy = energyData
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
          .toString(); // GET SUM OF ENERGY FOR ALL CLUSTER FOR THIS MONTH

        // Calculation for total cost

        this.totalCost = totalCost
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
          .toString();

        this.co2Reduction =
          (this.totalEnergy * 0.694).toFixed(2).toString() + " KG";

        let chartData = {
          labels: date,
          datasets: [
            {
              label: "Energy",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: energyData,
            },
          ],
        };
        this.lineChart1.chartData = chartData;

        
      });
    },
    initLineGraph(data) {
      Promise.all(data).then((res) => {
       
        // INITIALIZE DATES BASED ON CURRENT MONTH (Y AXIS)
        let date = [];
        let energyData = [];
        let firstDay = moment().startOf("month");

        for (let i = 1; i <= moment().daysInMonth(); i++) {
          date.push(moment(firstDay).format("Do"));
          firstDay = moment(firstDay).add(1, "days");
        }

        for (let i = 0; i < parseInt(moment().format("D")); i++) {
          energyData.push(0);
        }
        //////////////////////////////////////////////////////

        let currentMonth = moment().tz("Asia/Kuala_Lumpur").format("MM");

        let totalCost = [];
        let count = 0;
        // STORING ALL ENERGY DATA FOR ALL CLUSTER
        for (let i = 0; i < res.length; i++) {
          if (res[i] != undefined) {
            for (let j = 0; j < res[i].length; j++) {
              if (
                moment.unix(res[i][j].timestamp).format("MM") == currentMonth
              ) {
                energyData[
                  parseInt(moment.unix(res[i][j].timestamp).format("D")) - 1
                ] += res[i][j].energy / 1000;
              }

              //total sum cost each cluster based on their tariff
             

              totalCost[count] =
                energyData.reduce((a, b) => a + b, 0) * res[i][0].tariff;
            }
          }

          count++;
        }

       
        this.totalEnergy = energyData
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
          .toString(); // GET SUM OF ENERGY FOR ALL CLUSTER FOR THIS MONTH

        // Calculation for total cost

        this.totalCost = totalCost
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
          .toString();

        this.co2Reduction =
          (this.totalEnergy * 0.694).toFixed(2).toString() + " KG";

        let chartData = {
          labels: date,
          datasets: [
            {
              label: "Energy",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: energyData,
            },
          ],
        };
        this.lineChart1.chartData = chartData;

        
      });
    },
    getClusterTariff(clusterID) {
      return new Promise((resolve, reject) => {
        this.$http
          .get(":8002/api/v1/manage/cluster/" + clusterID)
          .then((res) => {
            if (res.error) {
              swal({
                type: "error",
                title: "Oops... Something went wrong!",
                text: res.message,
              });
            } else {
              this.clusterFullData = res.message;
              let data = res.message;

              //get attribute data
              data.cluster_attribute.map((i) => {
              
                i.key == "CLUSTER_TARIFF_RATE"
                  ? resolve(parseFloat(i.value))
                  : null;

                // i.key == "CLUSTER_TARIFF_RATE"
                //   ? (this.clusterTariff = parseFloat(i.value))
                //   : 0;
              });
            }
          })
          .catch((err) => {
            reject(err);
          });
      });

      // let val = this.clusterTariff;
      
      // // this.clusterTariff = 0;
      // return val;
    },
    getClusterInfo(cluster_id) {
      return this.$http.get(":8002/api/v1/manage/cluster/" + cluster_id).then(res => {
        if (!res.error) {
       
          let tariff = 0
          let watt = 0
          // let lightCount = 0
          let scheduleList = []
          // let deviceList = res.message.device_list.length
          // this.totalUsedLight = deviceList
       // get light count
      
       for (let i = 0; i < res.message.device_list.length; ++i) {
        
            if (res.message.device_list[i].devicetype == "nodestl") {
              
              this.lightCount++;
            } else {
             
            }


          }
          let deviceList = this.lightCount;
          this.totalUsedLight = this.lightCount;
          this.totalLights = this.lightCount.toString();
       

          //GET LAMP WATT AND TARIFF
          res.message.cluster_attribute.map((i) => {
            i.key === "CLUSTER_TARIFF_RATE"
              ? (tariff = parseFloat(i.value))
              : 0;

            i.key == "CLUSTER_LIGHTS_WATT"
              ? (watt = parseInt(i.value, 10))
              : 0;
          });

          let firstDay = moment().startOf("month");
          let date = []
          let monthlyEnergy = []
          let today = moment().format("D");
          //GET DAYS OF MONTH 
          for (let i = 1; i <= today; i++) {
            let sumTotalEnergy = 0.0
            let sumTotalCost = 0
            date.push(moment(firstDay).format("Do"));
        
            let obj = {}
            obj["day"] = moment(firstDay).format("D")
            if (firstDay.day() == 0 || firstDay.day() == 6) {
              scheduleList = res.message.schedule_info.weekends
            } else {
              scheduleList = res.message.schedule_info.weekdays
            }

            //ITERATE EACH GET ENERGY TOTAL FOR DAY 
            for (let i = 0; i < scheduleList.length; i++) {

              if (i + 1 != scheduleList.length) {
                //GET WATT
               
                let w = watt * ((parseInt(scheduleList[i].slice(12, 14), 16) * 10) / 100)
         
                //GET RUNNING TIME 
                let time1 = moment(parseInt(scheduleList[i].slice(6, 8), 16).toString() + ":" +
                  parseInt(scheduleList[i].slice(8, 10), 16).toString(), "HH:mm")
                let time2 = moment(parseInt(scheduleList[i + 1].slice(6, 8), 16).toString() + ":" +
                  parseInt(scheduleList[i + 1].slice(8, 10), 16).toString(), "HH:mm")
                let duration = moment.duration(time2.diff(time1));
                let runningHour = parseFloat(duration.asHours());

                //GET ENERGY 
                if (i == 5) {
                  runningHour = 1
                }
                sumTotalEnergy += (w * runningHour) / 1000
              }
            }



           
            firstDay = moment(firstDay).add(1, "days");
            obj["val"] = sumTotalEnergy * deviceList
            obj["tariff"] = tariff
            monthlyEnergy.push(obj)

          }


         

          return monthlyEnergy






         



        }
      });
    },
    getClusterData(cluster_id) {
      let reshapeData = [];
      let today = moment().unix();
      let later = moment().subtract(1, "months").startOf("day").unix();
      


      //get cluster tariff
      return this.getClusterTariff(cluster_id).then((a) => {
        this.clusterTariff = a;

       
        //GET SCHEDULE BASE ON CLUSTER
      

        return this.$http
          .get(
            ":8001/api/v1/telemetry/cluster/" +
            cluster_id +
            "/" +
            later +
            "/" +
            today
          )
          .then((res) => {
            if (res.error) {
             
            } else {
              if (res.message.cluster_data) {
                
                let data = res.message.cluster_data;

                for (var item of data) {
                  let dta = JSON.parse(JSON.parse(item.value));
             
                  if (item.value != "null") {
                    let obj = {};
                    obj["clusterid"] = cluster_id;
                    obj["timestamp"] = item.timestamp;
                    obj["energy"] = JSON.parse(JSON.parse(item.value)).energy;
                    obj["tariff"] = this.clusterTariff;
                    reshapeData.push(obj);
                  }
                }

                return reshapeData;
              } else {
                
              }
            }
          });
      });
    },
    plotGraph() {
      this.lightCount = 0
      let _clusterList = this.getTotalCluster();
      let combinedData = [];
      let combinedData1 = [];
      let totalUsedLights = 0
      _clusterList.then((result) => {
        for (let i = 0; i < result.length; i++) {
        
          let s = this.getClusterData(result[i].id);
          let g = this.getClusterInfo(result[i].id);
          combinedData.push(s);
          combinedData1.push(g)
          totalUsedLights += result[i].totalLights
        }

     
        // this.initLineGraph(combinedData);
      
        this.totalLights = totalUsedLights.toString();
        this.initGraph(combinedData1)
      });
    },
  },
  mounted() {
    this.isLoading = true;
    // let jwt_token = sessionStorage.getItem("token").split(".")[1];
    let jwt_token = this.$cookie.get("token").split(".")[1];
    jwt_token = JSON.parse(atob(jwt_token));
    
    this.companyID = jwt_token.Companyid;

    this.currentMonth = moment().format("MMMM");

    // set default
    this.commUprate = "Checking...";

    this.plotGraph();
    setTimeout(this.getCommUprate,5000)

    this.getTotalLights();
    this.getTotalCluster();
    // this.getCommUprate();
    this.getGatewayList();
    // this.plotGraph();
  },
};
</script>
<style scoped>
.row {
  overflow: hidden;
}

.header h3 {
  display: inline;
}

.inlinethings p {
  display: inline;
}
</style>
